import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import Search from '@/components/Search/search'
import Login from '@/components/Login/login'
import Register from '@/components/Login/register'
import RetrievePass from '@/components/Login/retrievePass'
import HomePage from '@/components/Home/homePage'
import SpecialOffer from '@/components/SpecialOffer/specialoffer'
import Newest from '@/components/SpecialOffer/newest'
import Free from '@/components/SpecialOffer/free'
import ZbRecommend from '@/components/SpecialOffer/zbRecommend'
import NewUp from '@/components/SpecialOffer/newUp'
import Classification from '@/components/Classification/classification'
import Ranking from '@/components/Ranking/ranking'
import Theme from '@/components/Theme/theme'
import ThemeDetails from '@/components/Theme/themeDetails'
import ReadingCard from '@/components/ReadingCard/readingcard'
import Personal from '@/components/Personal/personal'
import MyBookshelf from '@/components/Personal/MyBookshelf/mybookshelf'
import MyOrder from '@/components/Personal/MyOrder/myorder'
import MyCollection from '@/components/Personal/MyCollection/mycollection'
import MyRecord from '@/components/Personal/MyRecord/myrecord'
import MyCoupon from '@/components/Personal/MyCoupon/mycoupon'
import Settings from '@/components/Personal/Settings/settings'
import SettingsUser from '@/components/Personal/Settings/settingsuser'
import AllOrder from '@/components/Personal/MyOrder/allOrder'
import WaitPay from '@/components/Personal/MyOrder/waitPay'
import WaitFh from '@/components/Personal/MyOrder/waitFh'
import WaitSh from '@/components/Personal/MyOrder/waitSh'
import ShoppingCart from '@/components/ShoppingCart/shoppingcart'
import PaperBook from '@/components/ShoppingCart/paperbook'
import EBook from '@/components/ShoppingCart/ebook'
import OrderDetails from '@/components/OrderDetails/orderDetails'
import OrderDetails1 from '@/components/OrderDetails/orderDetails1'
import Book from '@/components/book/book'
import GoodsDetails from '@/components/GoodsDetails/goodsDetails'
import Pay from '@/components/pay/pay'
// import T404 from '@/components/404/404'
Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/aa/',
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    // redirect: '/home',
    children: [{
      path: '/home/orderdetails',
      name: 'OrderDetails',
      component: OrderDetails
    }, {
      path: '/home/orderdetails1',
      name: 'OrderDetails1',
      component: OrderDetails1
    }, {
      path: '/home/shoppingcart',
      name: 'ShoppingCart',
      component: ShoppingCart,
      redirect: '/home/shoppingcart/paperbook',
      children: [{
        path: '/home/shoppingcart/paperbook',
        name: 'PaperBook',
        component: PaperBook
      }, {
        path: '/home/shoppingcart/ebook',
        name: 'EBook',
        component: EBook
      }]
    }, {
      path: '/home',
      name: 'HomePage',
      component: HomePage
    }, {
      path: '/home/search',
      name: 'Search',
      component: Search
    }, {
      path: '/home/specialoffer',
      name: 'SpecialOffer',
      component: SpecialOffer,
      redirect: '/home/specialoffer/newest',
      children: [{
        path: '/home/specialoffer/newest',
        name: 'Newest',
        component: Newest
      }, {
        path: '/home/specialoffer/free',
        name: 'Free',
        component: Free
      }, {
        path: '/home/specialoffer/zbrecommend',
        name: 'ZbRecommend',
        component: ZbRecommend
      }, {
        path: '/home/specialoffer/newup',
        name: 'NewUp',
        component: NewUp
      }]
    }, {
      path: '/home/pay',
      name: 'Pay',
      component: Pay
    }, {
      path: '/home/goodsdetails',
      name: 'GoodsDetails',
      component: GoodsDetails
    }, {
      path: '/home/classification',
      name: 'Classification',
      component: Classification
    }, {
      path: '/home/ranking',
      name: 'Ranking',
      component: Ranking
    }, {
      path: '/home/theme',
      name: 'Theme',
      component: Theme
    }, {
      path: '/home/theme/themeDetails',
      name: 'ThemeDetails',
      component: ThemeDetails
    }, {
      path: '/home/readingcard',
      name: 'ReadingCard',
      component: ReadingCard
    }, {
      path: '/home/personal',
      name: 'Personal',
      component: Personal,
      children: [{
        path: '/home/personal/mybookshelf',
        name: 'MyBookshelf',
        component: MyBookshelf
      }, {
        path: '/home/personal/myorder',
        name: 'MyOrder',
        component: MyOrder,
        redirect: '/home/personal/myorder/allOrder',
        children: [{
          path: '/home/personal/myorder/allOrder',
          name: 'AllOrder',
          component: AllOrder
        }, {
          path: '/home/personal/myorder/waitPay',
          name: 'WaitPay',
          component: WaitPay
        }, {
          path: '/home/personal/myorder/waitFh',
          name: 'WaitFh',
          component: WaitFh
        }, {
          path: '/home/personal/myorder/waitSh',
          name: 'WaitSh',
          component: WaitSh
        }]
      }, {
        path: '/home/personal/mycollection',
        name: 'MyCollection',
        component: MyCollection
      }, {
        path: '/home/personal/myrecord',
        name: 'MyRecord',
        component: MyRecord
      }, {
        path: '/home/personal/mycoupon',
        name: 'MyCoupon',
        component: MyCoupon
      }, {
        path: '/home/personal/settings',
        name: 'Settings',
        component: Settings,
        redirect: '/home/personal/settings/settingsuser',
        children: [{
          path: '/home/personal/settings/settingsuser',
          name: 'SettingsUser',
          component: SettingsUser
        }]
      }]
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/register',
    name: 'Register',
    component: Register
  }, {
    path: '/retrievepass',
    name: 'RetrievePass',
    component: RetrievePass
  }, {
    path: '/book',
    name: 'Book',
    component: Book
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js